import * as React from 'react';
import renderIcon from 'helpers/renderIcon';
import Customer from 'components/Common/Customer';
import { ICustomer } from 'models/shop/customer';
import { DropdownModal } from 'components/Common/DropdownModal';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
const classNames = require('classnames');

require('./style.scss');

export interface BookingCustomerDropdownItem {
	text?: any;
	className?: string;
	onClick?: () => void;
}

interface IProps {
	customer?: ICustomer;
	onClick?: () => void;
	dropdownOptions?: BookingCustomerDropdownItem[];
	hideIcon?: boolean;
	namePlaceholder?: string;
	subtitlePlaceholder?: string;
}

interface IState {}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
export class BookingCustomer extends React.Component<IProps, IState> {
	public render() {
		const { namePlaceholder, subtitlePlaceholder, onClick, customer, dropdownOptions, hideIcon } = this.props;

		return (
			<div
				className={classNames('booking-customer', { clickable: !!onClick, withDropdown: !!customer })}
				onClick={onClick}
			>
				<div className="booking-customer__customer-container">
					<Customer customer={customer || { name: namePlaceholder, email: subtitlePlaceholder }} size="bigSize" />
				</div>
				{!hideIcon && (
					<div className="booking-customer__icon-container">
						{customer ? (
							<DropdownModal
								className="forceLeft"
								buttonComponent={renderIcon('moreVerticalGray', 24, 24)}
								stopPropagation={false}
							>
								{dropdownOptions.map((option, i) => (
									<div className={option.className} key={`booking-customer-option-${i}`} onClick={option?.onClick}>
										{option.text}
									</div>
								))}
							</DropdownModal>
						) : (
							renderIcon('arrow_right_round', 24, 24)
						)}
					</div>
				)}
			</div>
		);
	}
}
